// extracted by mini-css-extract-plugin
export default {"feedbackModal":"assessmentfeedback_feedbackModal__C34b0"};